import { render, staticRenderFns } from "./PolicyCenter.vue?vue&type=template&id=21c05076&"
import script from "./PolicyCenter.vue?vue&type=script&lang=js&"
export * from "./PolicyCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports